import ErrorView                from 'scripts/defa/basic/view-error-view';
import RoleApplications         from 'scripts/defa/role-applications/collection-role-applications';
import RoleApplication          from 'scripts/defa/role-applications/model-role-application';
import { defa }                 from '../../../defa-object';
import Controller               from '../../poppet/controller';
import RoleApplicationContainer from './view-role-application-container.js';

/**
 * defa.controllers.RoleApplicationController
 * The controller for the RoleApplicationRouter
 * @version 1.0.0
 */
const channelLayout = Bb.Radio.channel( 'layout' ),
	  channelNav    = Bb.Radio.channel( 'nav' ),
	  channelUser   = Bb.Radio.channel( 'user' ),
      channel   = Bb.Radio.channel( 'object' );


const RoleApplicationController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	/**
	 * Shows the application reject/approve-interface
	 * @void
	 */
	showRoleApplication: function ( id ) {
		this.requireRoleApplication( {
			view     : 'role:application',
			roleApplicationId   : id,
			callback : this.attachRoleApplicationContainer,
			closeLink: {
				event : 'roleapplication:list',
			},
		} );
	},
	
	/**
	 * Shows the application collectionView-interface
	 * @void
	 */
	showAllRoleApplications: function () {
		let roleApplications = new RoleApplications();
		this.listenToOnce(roleApplications, 'reset', function(){
			this.attachRoleApplicationContainer({
				view    : 'role:applications',
				roleApplications : roleApplications,
				closeLink: {
					event: 'app:home',
				},
			});
		});
		
		roleApplications.fetchAllRoleApplications({
			error: function(response){
				let errorView = new ErrorView( response.responseJSON );
				channelLayout.request( 'root' ).showChildView( 'main', errorView );
			}
		});
	},

	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Requests a single roleApplication before calling the callback.
	 * @param {Object} options All the needed options, most importantly a recipientGroupHolderId and a callback function.
	 * @void
	 */
	requireRoleApplication: function ( options ) {
		this.requireModel( 'RoleApplication', defa.models, options );
	},
	
	/**
	 * Creates and displays a RoleApplicationContainer.
	 * @param {Object} options  An object containing all the needed objects for creating, listing and editing
	 *     application-information.
	 * @void
	 */
	attachRoleApplicationContainer: function ( options ) {
		options           = options || {};
		options.user      = options.user || channelUser.request( 'model' );
		options.noLogin   = options.noLogin || false;
		
		
		// if user isn't logged in, and this view isn't a no-login view, route to search.
		if ( channelUser.request( 'is:logged:out' ) && !options.noLogin ) {
			channelNav.trigger( 'user:login', { trigger: true, replace: true, } );
		}
		// if the user is not tech support, redirect to home page.
		else if(!channelUser.request('is:techsupport')){
			channelNav.trigger( 'app:home', { trigger: true, replace: true, } );
		}
		// if the user is logged in, play with the subscriptionContainer.
		else {
			
			let self = options.self || this;
			
			// if the RoleApplicationContainer isn't made or is destroyed, create it and attach it's listeners
			if ( !( self.roleApplicationContainer instanceof RoleApplicationContainer ) || self.roleApplicationContainer.isDestroyed() ) {
				self.roleApplicationContainer = new RoleApplicationContainer( options );
				
				// if it already exists, just update it's options
			} else {
				self.roleApplicationContainer.settings( options );
			}
			
			// if the container isn't attached yet, attach it to the DOM
			if ( !self.roleApplicationContainer.isAttached() ) {
				channelLayout.request( 'root' ).showChildView( 'main', self.roleApplicationContainer );
			}
		}
	},
	
} );

export default RoleApplicationController;